var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header',{attrs:{"icon":"fad fa-space-shuttle","title":"Modely spotřebičů"},scopedSlots:_vm._u([{key:"buttons",fn:function(){return [_c('PrimaryLinkButton',{attrs:{"to":"/setup/boilers/models/create","icon":"fad fa-plus-circle","text":"Přidat model spotřebiče"}})]},proxy:true}])}),_c('BoilerModelsList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }